import * as yup from "yup";
import moment from "moment";

const isISO8601 = (dateString: string) => {
  const dateISO = moment(dateString, moment.ISO_8601);
  return dateISO.isValid();
};

export const rowSchema = yup.object().shape({
  package_tracking_number: yup.string().trim().required("package tracking number is required"),
  date: yup
    .string()
    .trim()
    .required("date is required")
    .test("dateISO8601", "date format should be YYYY-MM-DD", (date) => {
      if (!date) return false;
      return isISO8601(date);
    }),
  time_slot: yup
    .string()
    .trim()
    .required("time_slot is required")
    .matches(/^\d{2}-\d{2}$/, "time_slot format should be HH-HH. Ex. 09-21"),
});
